/**
 * @generated SignedSource<<33299319f9ad84239f2ccd6c0a82d3ef>>
 * @relayHash 635a13fff445c744928cbff4d74f9f0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d12e70cf65c07e50e67037afc1cd48245ac64ce02a118cccfb98dfaad67bedcf

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "type"
      }, {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "default"
        }]
      }, {
        "args": [{
          "fields": [{
            "items": [{
              "kind": "Variable",
              "name": "ids.0",
              "variableName": "pageAri"
            }],
            "kind": "ListValue",
            "name": "ids"
          }],
          "kind": "ObjectValue",
          "name": "filter"
        }],
        "concreteType": "HelpCenterPage",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [v4 /*: any*/, {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdf",
            "kind": "LinkedField",
            "name": "layoutAdf",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentConnection",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "concreteType": "HelpCenterLayoutAdfContent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "name": "content"
                  }]
                }]
              }]
            }]
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [v4 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "d12e70cf65c07e50e67037afc1cd48245ac64ce02a118cccfb98dfaad67bedcf",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "f9c63e162e1744e492c23330c3440cc6";
export default node;